"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../../../helpers");
var ICON_SIZE = '20px';
exports.VERTICAL_PADDING = (parseInt(helpers_1.SPACING_XL, 10) - parseInt(ICON_SIZE, 10)) / 2 + "px";
var MODE;
(function (MODE) {
    MODE["noSelected"] = "noSelected";
    MODE["selected"] = "selected";
    MODE["indeterminate"] = "indeterminate";
})(MODE = exports.MODE || (exports.MODE = {}));
exports.CentralFigure = styled_components_1.default.polygon(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.CheckboxIconWrapper = styled_components_1.default.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), ICON_SIZE);
exports.CheckboxIcon = function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.isError, isError = _c === void 0 ? false : _c, _d = _a.mode, mode = _d === void 0 ? MODE.noSelected : _d, rest = __rest(_a, ["isDisabled", "isError", "mode"]);
    return (react_1.default.createElement(exports.CheckboxIconWrapper, { "data-selector-id": rest['data-selector-id'] || 'checkbox-icon', viewBox: "0 0 20 20", width: "20px", height: "20px", "background-color": "currentColor", isDisabled: isDisabled, isError: isError },
        mode === MODE.selected && (react_1.default.createElement(exports.CentralFigure, { points: "8 15.5 17 6.5 15 4.5 8 11.5 5 8.5 3 10.5 8 15.5" })),
        mode === MODE.indeterminate && react_1.default.createElement(exports.CentralFigure, { points: "5,5 15,5 15,15 5,15" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M0,0V20H20V0ZM19,19H1V1H19Z" })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=CheckboxIcon.js.map